import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-300 bg-background-200">
      <div className="grid grid-cols-1 gap-10 px-4 py-12 md:grid-cols-12 md:gap-8 md:px-10 md:py-16">
        <div className="md:col-span-4">
          <div className="flex items-end gap-3">
            <span className="font-heading text-2xl font-black text-foreground-950">黑料总站</span>
            <span className="pb-1 font-label text-[10px] uppercase tracking-[0.35em] text-foreground-400">
              Gossip Central
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-loose text-foreground-600">
            把站内最新、更新与今日热点收在同一页，让你随时掌握话题的新进展，不用在多个入口之间来回切换。
          </p>
          <div className="mt-6 flex items-center gap-3">
            {["ri-wechat-line", "ri-weibo-line", "ri-rss-line"].map((icon) => (
              <a
                key={icon}
                href="#top"
                aria-label="社交入口"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                <i className={`${icon} text-base`} />
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-8">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-[11px] uppercase tracking-[0.25em] text-foreground-400">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-background-300 px-4 py-5 text-xs text-foreground-500 md:flex-row md:px-10">
        <span>© 2026 黑料总站 · 站内内容为信息聚合与话题展示</span>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <a href="#top" className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600">
            更新说明
          </a>
          <a href="#top" className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600">
            内容纠错
          </a>
          <a href="#top" className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600">
            编辑准则
          </a>
        </div>
      </div>
    </footer>
  );
}